__turbopack_context__.v({
  "active": "filterBasicGroup-module-scss-module__PVI7iq__active",
  "box": "filterBasicGroup-module-scss-module__PVI7iq__box",
  "checked": "filterBasicGroup-module-scss-module__PVI7iq__checked",
  "counter": "filterBasicGroup-module-scss-module__PVI7iq__counter",
  "dropdown": "filterBasicGroup-module-scss-module__PVI7iq__dropdown",
  "filterCheckboxHeader": "filterBasicGroup-module-scss-module__PVI7iq__filterCheckboxHeader",
  "filterCheckboxWrapper": "filterBasicGroup-module-scss-module__PVI7iq__filterCheckboxWrapper",
  "opened": "filterBasicGroup-module-scss-module__PVI7iq__opened",
  "option": "filterBasicGroup-module-scss-module__PVI7iq__option",
  "options": "filterBasicGroup-module-scss-module__PVI7iq__options",
  "search": "filterBasicGroup-module-scss-module__PVI7iq__search",
  "searchIcon": "filterBasicGroup-module-scss-module__PVI7iq__searchIcon",
  "searchInput": "filterBasicGroup-module-scss-module__PVI7iq__searchInput",
  "submenu": "filterBasicGroup-module-scss-module__PVI7iq__submenu",
  "title": "filterBasicGroup-module-scss-module__PVI7iq__title",
});
